<template>
  <div class="radio">
    <input
      type="radio"
      :checked="state"
      :id="id"
      :name="name"
      :value="value"
      @change="onChange"
    />
    <label :for="id">
      <span class="input-indicator"></span>
      <span class="label-value"><slot /></span>
    </label>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  props: {
    inline: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: [Number, String],
      required: false,
      default: null
    },
    modelValue: {
      default: null
    }
  },
  computed: {
    state () {
      return this.modelValue === this.value
    }
  },
  data () {
    return {
      id: null
    }
  },
  methods: {
    onChange () {
      this.$emit('input', this.state ? '' : this.value)
    }
  },
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  mounted () {
    this.id = `radio-${uuid()}`
  }
}
</script>

<style lang="scss" scoped>

  .radio {
    display: flex;

    input {
      @include visually-hidden();
    }

    label {
      @include deprecated-f-color-dark;
      @include label-med;
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      @include transition-fast;
      border-radius: 4px;
      padding: $d-tiny;
      border: 1px solid rgba($deprecated-brand-tertiary, 0);
    }

    .label-value {
      order: 2;
      @include transition-fast;
    }

    .input-indicator {
      order: 1;
      position: relative;
      height: $d-x-small;
      width: $d-x-small;
      border-radius: $d-x-small*2;
      border: $line-medium;
      margin-right: $d-xx-small;
      position: relative;
      @include transition-fast;
      display: inline-flex;
      justify-content: center;

      &:after {
        content: "";
        align-self: center;
        background-color: $color-white;
        height: $d-tiny;
        width: $d-tiny;
        border-radius: $d-tiny*2;
        pointer-events: none;
        @include transition-fast;
        opacity: 0;
        visibility: hidden;
        transform: scale(0);
      }
    }

    input:checked {
      & ~ label .input-indicator {
        background-color: $deprecated-brand-tertiary;
        border-color: $deprecated-brand-tertiary;
        &:after {
          opacity: 1;
          visibility: visible;
          transform: scale(1);
        }
      }
    }

    input:focus {
      & ~ label {
        color: $deprecated-brand-secondary;
        padding: $d-tiny;
        border: $line-focus;

        .input-indicator {
          border-color: $deprecated-brand-tertiary;
        }
      }
    }

    input:checked:focus ~ label .input-indicator {
      box-shadow: 0 0 4px $deprecated-brand-tertiary;
    }
  }
</style>
